<template>
  <div class="app">
    <div style="width:100vw;height:7.71vh;display:flex;flex-wrap:wrap;align-items:center;">
      <img src="@/assets/logo.png" style="width:12.56vw;height:12.56vw;margin-left:5.13vw;margin-right:2.56vw" />
      <div style="width:60vw;display:flex;flex-wrap:wrap">
        <div style="font-size:5vw;font-weight:bold;">Loop</div>
        <div style="font-size:2vw;width:64vw;">Professional platform for skipping rope training</div>
      </div>
      <div style="width:14vw;display:flex;flex-wrap:wrap;justify-content:center;" @click="pullAppEn()">
        <img src="@/assets/download.png" style="width:7vw;height:7vw" />
        <div style="font-size:2vw">Download</div>
      </div>
    </div>
    <div style="width:100vw;height:92.29vh;display:flex;flex-wrap:wrap;align-items:start;justify-content:center;background-image: linear-gradient(#103fd8, #00b1ff);color:#103fd8;position:relative">
      <img src="@/assets/prize.png" style="margin-top:4.74vh;width:54vw;height:20.38vh"/>
      <div style="width:88vw;height:59vh;box-shadow: 0px 3px 5px rgba(103, 1, 198, 0.47);border-radius:9vw;background:#FFFFFF;position:absolute;top:21vh;display:flex;flex-wrap:wrap;justify-content:center;align-content:start;">
        <img :src="parm5" style="margin-top:2.31vh;width:16vw;height:16vw;border-radius:50%" v-if="parm5">
        <div style="margin-top:2.31vh;width:16vw;height:16vw;border-radius:50%" v-else></div>
        <div style="font-size:2vw;color:black;width:100%;display:flex;justify-content:center;">{{ parm4 }}</div>
        <div style="width:73vw;height:1px;border-bottom:1px dashed #08A4FE"></div>
        <div style="width:100%;text-align:center;font-size:6vw;color:#0B9FFD;margin-bottom:4px;">Hi, I joined the Game</div>
        <div style="width:100%;text-align:center;font-size:6vw;color:#0B9FFD;margin-bottom:5px;">Come fight with me！</div>
        <div style="width:88vw;height:21.33vh;position:relative;z-index:2;">
          <img src="@/assets/background.png" style="width:100%;height:100%;position:absolute;z-index:1;left:0;"/>
          <div style="position:absolute;z-index:2;left:8vw;top:1.39vh;font-size:3vw;" :style="{color:competition.status == 1 ? '#FF5656' : '#0c7ded'}">{{competition.status == 1 ? 'Games Pending': 'Games Ongoing'}}</div>
          <div style="position:absolute;z-index:2;left:8vw;top:4.16vh;font-size:4vw;color:white;">{{competition.name}}</div>
          <div style="position:absolute;z-index:2;left:8vw;top:7.87vh;font-size:3vw;color:white;">{{competition.itemType == '1' ? 'Counter Mode: ' : 'Timer Mode: '}}{{competition.itemType == '1' ? competition.turnCount : Math.ceil((competition.finishedDuration) / 60) + ' min;'}} {{competition.times == 0 || competition.times == undefined ? 'Unlimited trials' : competition.times + ' times to submit the best'}}</div>
          <div style="position:absolute;z-index:2;left:8vw;top:11.11vh;font-size:3vw;color:#0c7ded;width:18vw;height:2.31vh;display:flex;justify-content:center;align-items:center;border:1px solid #0c7ded">{{competition.groupType == 1 ? 'Individual' : 'Team Play'}}</div>
          <div style="position:absolute;z-index:2;left:8vw;top:14.81vh;font-size:3vw;color:white;">Initiator: {{competition.creator}}</div>
          <div style="position:absolute;z-index:2;left:8vw;top:18.01vh;font-size:3vw;color:white;">Start Time: {{convertTimeToShow(competition.startTime)}} End Time: {{convertTimeToShow(competition.endTime)}}</div>
        </div>
        <div v-if="competition.inviteCode" style="width:100%;text-align:center;font-size:4vw;color:#6A6A6A;margin-bottom:0.5vh;margin-top:1.85vh;">Invitation Code</div>
        <div v-if="competition.inviteCode" style="width:100%;text-align:center;font-size:4vw;color:#6A6A6A;margin-bottom:1.38vh;">(Long press the button below to copy)</div>
        <div v-if="competition.inviteCode" style="width:36vw;height:5vh;border-radius:5vw;background: linear-gradient(181deg, #00B1FF 0%, #00B1FF 0%, #335DF7 100%);color:white;font-size:5vw;display:flex;justify-content:center;align-items:center;">{{competition.inviteCode}}</div>
      </div>
      <div @click="openLoopApp()" style="width:72vw;height:6vh;background:#FFD500;box-shadow:0px 1px 2px rgba(0, 0, 0, .16);border-radius:5vw;color:white;font-size:5vw;position:absolute;top:85vh;display:flex;justify-content:center;align-items:center;">Go to Loop to see more</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "app",
    data: function() {
      return {
        parm1: 0,
        parm2: 0,
        parm3: 0,
        parm4: '',
        parm5: '1D3E',
        competition: {
          status: 1,
          name: 'Loop',
          itemType: 2,
          turnCount: 200,
          creator: 'Loop',
          startTime: 1628593200,
          endTime: 1630641600,
          times: 0,
          inviteCode: '',
          finishedDuration: 90,
        },
      };
    },
    mounted() {
      let query = this.$route.query;
      this.parm1 = query.parm1,
      this.parm2 = query.parm2,
      this.parm3 = query.parm3,
      this.parm4 = query.parm4,
      this.parm5 = query.parm5,
      this.getData();
    },
  
    methods: {
      async getData() {
        let res = await this.axios.post('https://api.loopsports.cn/jump/getCompetitionForShare', {
          id: this.parm1 - 0,
          ut: this.parm2 - 0,
          sign: this.parm3
        });
        let data = res.data.Data;
        if (data == null) {
          return;
        }
        this.competition = data;
      },
      getDateFromTimestampUnitSecond(timestamp) {
        return new Date(timestamp * 1000);
      },
      convertIntToStringWithZero(num) {
        if (num < 10) {
          return `0${num}`;
        } else {
          return num;
        }
      },
      convertTimeToShow(timestamp) {
        let time = this.getDateFromTimestampUnitSecond(timestamp);
        return `${this.convertIntToStringWithZero(time.getMonth() + 1)}-${this.convertIntToStringWithZero(time.getDate())} ${this.convertIntToStringWithZero(time.getHours())}:${this.convertIntToStringWithZero(time.getMinutes())}`;
      },
      openLoopApp() {
        var device = navigator.userAgent;
        window.location.href = `loopischeme://joincompetition?id=${this.parm1}`;
        if (device.indexOf('Android') > -1) {
          setTimeout(() => {
            window.location.href = 'https://play.google.com/store/apps/details?id=com.justjump.loopintl'; 
          }, 3000)
        } else if (device.indexOf('iPhone') > -1) {
          window.setTimeout(() => {
            window.location.href = 'https://apps.apple.com/cn/app/id1617032569'; 
          }, 2000)
        }
      }
    },
  };
</script>

<style>

</style>
